import APIUtils from '@spothero/utils/api';
import ObjectUtils from '@spothero/utils/object';
import ErrorUtils from 'utils/error-utils';

export const getEvents = id => {
    return APIUtils.get(`/event-packages/${id}/`)
        .then(response => {
            try {
                return ObjectUtils.camelizeKeys(response.data.data);
            } catch (error) {
                return Promise.reject(new Error('Response shape unexpected.'));
            }
        })
        .catch(error => {
            ErrorUtils.sendSentryError(error);

            return ErrorUtils.formatError(error);
        });
};
